import React, {useState} from "react";
import {Document, Page, pdfjs} from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import Pager from "../../../components/Pager";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`

export default function PdfViewer({documento}) {

    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    function onDocumentLoadSuccess({numPages}) {
        setNumPages(numPages);
    }

    const handleContextMenu = (e) => {
        e.preventDefault();
    };

    return (
        <div className={"mb-5 mt-3 ns-pdf-view-box"}>
            <div className={"ns-pdf-view-container table-responsive mb-4"} onContextMenu={handleContextMenu}>
                <Document file={`data:application/pdf;base64,${documento.contenuto}`}
                          onLoadSuccess={onDocumentLoadSuccess}
                >
                    <Page pageNumber={pageNumber} renderTextLayer={false} className="pdf-page-container"/>
                </Document>
            </div>
            {numPages > 1 && (
                <div>
                    <span>Pagina {pageNumber} di {numPages}</span>
                    <Pager
                        pagina={pageNumber}
                        totale={numPages}
                        handlerCambioPagina={setPageNumber}
                    >
                    </Pager>
                </div>
            )}
        </div>
    );
}